module.exports = __webpack_public_path__ + "img/black-ink-deer-head-mens-chest-tattoo.jpg";